import React from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Link,
  Stack,
} from '@mui/material';

const GDPRPolicy = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        py: { xs: 4, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            padding: { xs: '24px', md: '40px' },
            borderRadius: { xs: 4, md: 6 },
            backgroundColor: '#fff',
            border: '1px solid rgba(16, 35, 63, 0.08)',
            boxShadow: '0 28px 70px rgba(16, 35, 63, 0.1)',
          }}
        >
          <Box component="section" sx={{ display: 'flex', flexDirection: 'column' }}>
            <Stack spacing={1.2} sx={{ mb: 4 }}>
              <Typography
                variant="overline"
                sx={{ color: 'secondary.main', letterSpacing: '0.16em', fontWeight: 700 }}
              >
                Privacy
              </Typography>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '2rem', md: '3rem' },
                  color: 'primary.main',
                  textAlign: { xs: 'left', md: 'center' },
                }}
              >
                GDPR Compliance Statement
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  maxWidth: 760,
                  alignSelf: { xs: 'stretch', md: 'center' },
                  textAlign: { xs: 'left', md: 'center' },
                }}
              >
                This website is intended as an information and marketing site. We keep data handling
                intentionally minimal and transparent.
              </Typography>
            </Stack>

            <Box sx={{ width: '100%', mb: 1 }}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 2, md: 3 },
                  mb: 3,
                  borderRadius: 4,
                  backgroundColor: '#f7fafc',
                  border: '1px solid rgba(16, 35, 63, 0.06)',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: '1.35em', md: '1.7em' },
                    color: 'primary.main',
                    fontWeight: 800,
                    mb: 2,
                  }}
                >
                  Purpose of This Website
                </Typography>
                <Typography variant="body1">
                  This website is designed solely for marketing purposes. Our goal is to provide
                  information about our products and services to interested parties.
                </Typography>
              </Paper>

              <Paper
                elevation={0}
                sx={{
                  p: { xs: 2, md: 3 },
                  borderRadius: 4,
                  border: '1px solid rgba(16, 35, 63, 0.06)',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: '1.35em', md: '1.7em' },
                    color: 'primary.main',
                    fontWeight: 800,
                    mb: 2,
                  }}
                >
                  Data Collection and Privacy
                </Typography>
                <Typography variant="body1" paragraph>
                  We respect your privacy. In alignment with the General Data Protection Regulation
                  (GDPR), we wish to inform you that:
                </Typography>

                <List>
                  <ListItem alignItems="flex-start">
                    <ListItemIcon sx={{ minWidth: 24 }}>
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          borderRadius: '50%',
                          backgroundColor: 'primary.main',
                          mt: 1.5,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography component="span" fontWeight="bold">
                          No Personal Data Collection:
                        </Typography>
                      }
                      secondary={
                        <Typography
                          component="span"
                          variant="body2"
                          color="text.primary"
                          sx={{ display: 'inline' }}
                        >
                          {' This website does not collect any form of personal data from its visitors.'}
                        </Typography>
                      }
                    />
                  </ListItem>

                  <ListItem alignItems="flex-start">
                    <ListItemIcon sx={{ minWidth: 24 }}>
                      <Box
                        sx={{
                          width: 6,
                          height: 6,
                          borderRadius: '50%',
                          backgroundColor: 'primary.main',
                          mt: 1.5,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography component="span" fontWeight="bold">
                          Cookies and Tracking:
                        </Typography>
                      }
                      secondary={
                        <Typography
                          component="span"
                          variant="body2"
                          color="text.primary"
                          sx={{ display: 'inline' }}
                        >
                          {' We do not use cookies or any tracking mechanisms that collect personal data.'}
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  For any queries regarding our data policy, please contact us at{' '}
                  <Link
                    href="mailto:heinrich.venter@quantummindsoftware.com"
                    color="secondary"
                    underline="hover"
                  >
                    heinrich.venter@quantummindsoftware.com
                  </Link>
                  .
                </Typography>
              </Paper>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default GDPRPolicy;
